import PropTypes from 'prop-types';
import useComponentVisible from '../../hooks/useComponentVisible';

const ChangeLanguage = ({ currLang, languagesMap, handleSwitch, className }) => {
	const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

	const onShowDrawerClick = () => {
		setIsComponentVisible(!isComponentVisible);
	};

	return (
		<div ref={ref} className={`change-language ${className}`}>
			<button
				className="btn typography typography--light"
				onClick={onShowDrawerClick}
			>
				{currLang}
			</button>
			<div
				className={`cc-drawer cc-drawer--desktop ${
					isComponentVisible ? 'cc-drawer--show' : ''
				}`}
			>
				<ul className="change-language__languages">
					{Object.keys(languagesMap)
						.filter((lng) => lng !== currLang)
						.map((lng) => (
							<li className="change-language__languages-language" key={lng}>
								<button
									onClick={() => handleSwitch(lng)}
									className="btn btn--transparent typography typography--black"
								>
									{languagesMap[lng]}
								</button>
							</li>
						))}
				</ul>
			</div>
		</div>
	);
};

ChangeLanguage.propTypes = {
	languagesMap: PropTypes.object,
	handleSwitch: PropTypes.func,
	currLang: PropTypes.string,
	className: PropTypes.string,
};

export default ChangeLanguage;
